/* eslint-disable */
import React from 'react';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const snacks = useStore((state) => state.snacks);
  const setSnacks = useStore((state) => state.setSnacks);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.snacks.title')}</Title>
        <Text className='description' size='m' medium>
          {t('onboarding.snacks.subtitle')}
        </Text>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={snacks}
          onChange={(value) => {
            setSnacks(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'snacks',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={true}>
            <span>🍏</span> {t('onboarding.snacks.options.yes')}
          </Option>
          <Option value={false}>
            <span>🙅‍♀️</span> {t('onboarding.snacks.options.no')}
          </Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
